import { defineComponent as _defineComponent } from 'vue'
import { BuilderInterface } from "@/types/BuilderInterface";
  import { HouseDesignInterface } from "@/types/HouseDesignInterface";
  import { useIsDesktop } from "@/features/useIsDesktop";
  import { formatPrice } from "@/helpers/transformation/price";
  import { ref, computed, watch, Ref, onMounted, onBeforeUnmount } from "vue";

  import { useScrollDragMobile } from "@/features/useScrollDragMobile";

  interface Props {
    items: ({ id: string } | { _id: string })[];
    selectedItem: { id?: string; _id?: string };
    title: string;
    contentTitle?: string;
    isButtonCheckmarkOff?: boolean;
    isButtonBuilder?: boolean;
    isLogoSwipe?: boolean;
    isHouseSelectSlider?: boolean;
    showPrice?: boolean;
  }

  type Emits = (e: "onSelectItem", item: { id?: string; _id?: string }) => void;

  const buttonWidth = 170;
  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderSliderButtons',
  props: {
    items: {},
    selectedItem: {},
    title: {},
    contentTitle: {},
    isButtonCheckmarkOff: { type: Boolean },
    isButtonBuilder: { type: Boolean },
    isLogoSwipe: { type: Boolean },
    isHouseSelectSlider: { type: Boolean },
    showPrice: { type: Boolean }
  },
  emits: ["onSelectItem"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emits = __emit;
  const scrollOffset = ref(0);
  const step = buttonWidth;
  const buttonsContainer = ref<HTMLElement>();
  const isButtonClicked = ref(false);
  const itemClicked = ref<{ id?: string; _id?: string } | null>(null);
  const { isDesktop } = useIsDesktop(990);

  const isButtonCheckmark = (item: { id?: string; _id?: string }) =>
    props.selectedItem?._id === item._id && !props.isButtonCheckmarkOff;
  const isButtonCheckmarkNotIcon = (item: { id?: string; _id?: string }) =>
    props.selectedItem?._id === item._id && props.isButtonCheckmarkOff;
  const isButtonBuilder = () => props.isButtonBuilder;

  const { onTouchCancel, onTouchEnd, onTouchMove, onTouchstart } =
    useScrollDragMobile(buttonsContainer as Ref<HTMLElement>);

  const showControls = computed(() => {
    const MAX_ITEMS_WITHOUT_CONTROLS = 5;

    if (checkHasMobileEvents()) return false;

    return (
      props.items.length > MAX_ITEMS_WITHOUT_CONTROLS ||
      canDesktopScrollLeft.value ||
      canDesktopScrollRight.value
    );
  });
  const checkHasMobileEvents = () => {
    const MOBILE_EVENT = "ontouchstart";

    return MOBILE_EVENT in document.documentElement;
  };

  const containerStyles = computed(() => ({
    transform: `translateX(-${scrollOffset.value}px)`,
  }));

  const canDesktopScrollLeft = computed(
    () => scrollOffset.value > 0 && !!buttonsContainer.value
  );

  const canDesktopScrollRight = computed(() => {
    const containerWidth = buttonsContainer.value?.clientWidth ?? 0;
    const contentWidth = buttonsContainer.value?.scrollWidth ?? 0;
    const maxScrollOffset = contentWidth - containerWidth;

    return scrollOffset.value < maxScrollOffset && !!buttonsContainer.value;
  });

  const scrollDesktopRight = () => {
    if (canDesktopScrollRight.value) {
      scrollOffset.value += step;
    }
  };
  const scrollDesktopLeft = () => {
    if (canDesktopScrollLeft.value) {
      scrollOffset.value -= step;
    }
  };

  const onSelectItem = (item: { id?: string; _id?: string }) => {
    const idComparison = props.isHouseSelectSlider
      ? props.selectedItem?._id === item._id
      : props.selectedItem?.id === item.id;

    if (idComparison) {
      return;
    }

    emits("onSelectItem", item);

    isButtonClicked.value = true;
    itemClicked.value = item;
  };

  watch(
    () => props.items,
    () => {
      scrollOffset.value = 0;
    },
    { deep: true }
  );

  const resetOffsetHandler = () => {
    /**
     * Resets the scroll offset to fire the "showControls" computed property.
     */
    scrollOffset.value = -1;
    scrollOffset.value = 0;
  };

  onMounted(() => {
    window.addEventListener("resize", resetOffsetHandler);
  });

  onBeforeUnmount(() => {
    window.removeEventListener("resize", resetOffsetHandler);
  });

const __returned__ = { props, emits, scrollOffset, buttonWidth, step, buttonsContainer, isButtonClicked, itemClicked, isDesktop, isButtonCheckmark, isButtonCheckmarkNotIcon, isButtonBuilder, onTouchCancel, onTouchEnd, onTouchMove, onTouchstart, showControls, checkHasMobileEvents, containerStyles, canDesktopScrollLeft, canDesktopScrollRight, scrollDesktopRight, scrollDesktopLeft, onSelectItem, resetOffsetHandler, get BuilderInterface() { return BuilderInterface }, get HouseDesignInterface() { return HouseDesignInterface }, get useIsDesktop() { return useIsDesktop }, get formatPrice() { return formatPrice }, ref, computed, watch, Ref, onMounted, onBeforeUnmount, get useScrollDragMobile() { return useScrollDragMobile } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})